module.exports = __webpack_public_path__ + "media/images/flags/16/Mexico-15639bb0912e18294f58a640b537f69b.png";